import { Component } from "react";
import PropTypes from "prop-types";

export default class ScoreComponent extends Component {
  constructor() {
    super();
    this.state = {
      hideClass: "hide-opacity",
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        ...this.props,
        hideClass: "",
      });
    }, 500);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.setState({
        hideClass: "hide-opacity",
      });
      setTimeout(() => {
        this.setState({
          ...this.props,
          hideClass: "",
        });
      }, this.props.animationDuration * 1000);
    }
  }

  render() {
    const {
      date,
      place,
      score,
      verticalAlign,
      textPosition,
      hideClass,
      sportName,
    } = this.state;
    const isMLB = sportName === "mlb";
    return (
      <div
        className={`score-item vertical-align-${verticalAlign} text-position-${textPosition} ${hideClass}`}
        style={{
          transitionDuration: `${this.props.animationDuration}s`,
        }}
      >
        <div className="score-value">
          {(score && score.result) || (isMLB ? "at" : "VS")}
        </div>
        <div className="game-date-info">
          <div className="game-date">
            {date && date.weekday}, {date && date.date} {date && date.month}
          </div>
          <div className="game-time">{date && date.time}</div>
        </div>
        <div className="game-place-info">
          <div className="game-place">{place && place.stadium}</div>
        </div>
      </div>
    );
  }
}

ScoreComponent.propTypes = {
  date: PropTypes.exact({
    weekday: PropTypes.string,
    month: PropTypes.string,
    date: PropTypes.string,
    time: PropTypes.string,
  }),
  place: PropTypes.exact({
    stadium: PropTypes.string,
    country: PropTypes.string,
    city: PropTypes.string,
    address: PropTypes.string,
  }),
  score: PropTypes.exact({
    result: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  }),
  sportName: PropTypes.string,
  verticalAlign: PropTypes.oneOf(["center", "top", "bottom"]),
  textPosition: PropTypes.oneOf(["top", "bottom"]),
  animationDuration: PropTypes.number,
  id: PropTypes.number,
};

ScoreComponent.defaultProps = {
  date: {
    weekday: "TUE",
    month: "APR",
    date: "24",
    time: "10:30 PM",
  },
  place: {
    stadium: "Olimpyc",
    country: "Italy",
    city: "Rome",
    address: "Saint Paulo, 9",
  },
  score: {
    result: "0:0",
  },
  sportName: "nhl",
  verticalAlign: "center",
  textPosition: "bottom",
  duration: 30,
};
